// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oHUr","textarea":"styles_textarea__1DorY"};